import React, { useState, useContext, useRef } from "react";
import { useHistory, NavLink } from "react-router-dom";
import { useReactToPrint } from "react-to-print";

//pages & includes
import ManageSidebar from "../ManageSidebar";

//functions
import {
  _t,
  getCookie,
  tableLoading,
  pagination,
  paginationLoading,
  showingData,
  searchedShowingData,
} from "../../../../../functions/Functions";
import { useTranslation } from "react-i18next";

//axios and base url
import axios from "axios";
import { BASE_URL } from "../../../../../BaseUrl";

//3rd party packages
import { Helmet } from "react-helmet";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { MdDelete } from 'react-icons/md';

//context consumer
import { SettingsContext } from "../../../../../contexts/Settings";
import { UserContext } from "../../../../../contexts/User";
import { RestaurantContext } from "../../../../../contexts/Restaurant";
import CustomSpinLoader from "../../../../components/CustomSpinLoader";
import IngredientStockPrint from "./IngredientStockPrint";

const toastObj = {
  position: "bottom-center",
  autoClose: 10000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  className: "text-center toast-notification",
}
const StoreRequisition = () => {
    const { t } = useTranslation();
    //getting context values here
    let {
      //common
      loading,
      setLoading,
    } = useContext(SettingsContext);

    const {
      branchForSearch,
    } = useContext(RestaurantContext)
  
    let {

      //store requisition
      // getStoreRequisition,
      storeRequisitionList,
      setStoreRequisitionList,
      setPaginatedStoreRequisition,
      storeRequisitionForSearch,
      setStoreRequisitionForSearch,

      //pagination
      dataPaginating,
    } = useContext(UserContext);
  
    //search result
    let [searchedStoreRequisition, setSearchedStoreRequisition] = useState({
      list: null,
      searched: false,
    });
  
    //search customers here
    const handleSearch = (e) => {
      let searchInput = e.target.value.toLowerCase();
      if (searchInput.length === 0 || storeRequisitionForSearch === null) {
        setSearchedStoreRequisition({ ...searchedStoreRequisition, searched: false });
      } 
    else {
        let searchedList = storeRequisitionForSearch.filter((item) => {
          let lowerCaseDocumentNo = item.document_identity?.toLowerCase() || "";
          let lowerCaseDocumentDate = item.document_date?.toLowerCase() || "";
          let lowerCaseRemarks = item.remarks?.toLowerCase() || "";
          let fromBranch = item?.from_branch?.name?.toLowerCase() || "";
          let toBranch = item?.to_branch?.name?.toLowerCase() || "";
          let lowerCaseCreatedBy = item.created_by_name?.toLowerCase() || "";
          let lowerCaseUpdatedBy = item.updated_by_name?.toLowerCase() || "";
          let lowerCasePostedBy = (item.posted_by_name || item.post_by_name)?.toLowerCase() || "";
  
          return (
            lowerCaseDocumentNo.includes(searchInput) ||
            lowerCaseDocumentDate.includes(searchInput) ||
            fromBranch.includes(searchInput) ||
            toBranch.includes(searchInput) ||
            lowerCaseRemarks.includes(searchInput) ||
            lowerCaseCreatedBy.includes(searchInput) ||
            lowerCaseUpdatedBy.includes(searchInput) ||
            lowerCasePostedBy.includes(searchInput)
          );
        });
        setSearchedStoreRequisition({
          ...searchedStoreRequisition,
          list: searchedList,
          searched: true,
        });
      }
    };
  
    //delete confirmation modal of waiter
    // const handleDeleteConfirmation = (id) => {
    //   confirmAlert({
    //     customUI: ({ onClose }) => {
    //       return (
    //         <div className="card card-body">
    //           <h1>{_t(t("Are you sure?"))}</h1>
    //           <p className="text-center">{_t(t("You want to delete this?"))}</p>
    //           <div className="d-flex justify-content-center">
    //             <button
    //               className="btn btn-primary"
    //               onClick={() => {
    //                 // handleDeleteCustomer(id);
    //                 onClose();
    //               }}
    //             >
    //               {_t(t("Yes, delete it!"))}
    //             </button>
    //             <button className="btn btn-success ml-2 px-3" onClick={onClose}>
    //               {_t(t("No"))}
    //             </button>
    //           </div>
    //         </div>
    //       );
    //     },
    //   });
    // };
  
    // //delete customer here
    // const handleDeleteCustomer = (id) => {
    //   setLoading(true);
    //   const customerUrl = BASE_URL + `/settings/delete-opening-stock/${id}`;
    //   return axios
    //     .get(customerUrl, {
    //       headers: { Authorization: `Bearer ${getCookie()}` },
    //     })
    //     .then((res) => {
    //       setStoreRequisitionList(res.data[0]);
    //       setStoreRequisitionForSearch(res.data[1]);
    //       setSearchedStoreRequisition({
    //         ...searchedStoreRequisition,
    //         list: res.data[1],
    //       });
    //       setLoading(false);
    //       toast.success(`${_t(t("Store requisition has been deleted successfully"))}`, toastObj);
    //     })
    //     .catch(() => {
    //       setLoading(false);
    //       toast.error(`${_t(t("Please try again"))}`, toastObj);
    //     });
    // };

  //print bills states and function
  const [newRow,setNewRow]=useState([]);
  const [postingId, setPostingId] = useState(null);
  let [newStockReq, setNewStockReq] = useState({
    document_identity: '',
    documentDate: "",
    fbranch: '',
    tbranch: '',
    remarks: '',
    created_at: '',
  });
  const componentRef = useRef();
  const handleOnlyPrint = useReactToPrint({
    content: () => componentRef.current,
    pageStyle: `
        @page {
          margin: 15px 25px;
        }`
  });
  const handleGetPrintData = async(id) => {
    const url = BASE_URL + "/settings/storeRequisition/" + parseInt(id);
    try {
      const res = await axios.get(url, {
          headers: { Authorization: `Bearer ${getCookie()}` },
        });
        if(res.data && res.data){
          let docDate= new Date(res.data.document_date);
          setNewStockReq({
            ...newStockReq,
            documentDate: docDate,
            document_identity: res.data.document_identity,
            fbranch: res.data.from_branch,
            tbranch: res.data.to_branch,
            remarks: res.data.remarks,
            created_at: res.data.created_at,
          })
          if(res.data.store_requisition_detail && res.data.store_requisition_detail.length>0){
            setNewRow([...res.data.store_requisition_detail])
          }
          handleOnlyPrint();
        }
    } catch(error) {
      console.log("error==>",error)
      toast.error(`${_t(t("Please try again"))}`, toastObj);
    }
  }

  const handlePostApi = async(id) =>{
    setPostingId(id);
    const url = BASE_URL + "/settings/requistion-post-status";
    const formData = {
      id: id,
      is_post: 1
    }
    await axios
      .post(url,formData, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      })
    .then((res) => {
      setStoreRequisitionList(res.data[0]);
      setStoreRequisitionForSearch(res.data[1]);
      setSearchedStoreRequisition({
        ...searchedStoreRequisition,
        list: res.data[1],
      });
      setLoading(false);
      setPostingId(null);
      toast.success(`${_t(t("Stock requisition has been post"))}`, toastObj);  
    }).catch((error) =>{
      setLoading(false);
      setPostingId(null);
      if(error.response.data?.message){
        toast.error(`${_t(t(error.response.data.message))}`, toastObj);
        return
      }
      toast.error(`${_t(t("Please try again"))}`, toastObj);  
    })
  }
  
  return (
    <>
      <Helmet>
        <title>{_t(t("Store Requisition"))}</title>
      </Helmet>

      {/* main body */}
      <main id="main" data-simplebar>
        <div className="container-fluid">
          <div className="row t-mt-10 gx-2">
            {/* left Sidebar */}
            <div className="col-lg-2 col-xxl-2 t-mb-30 mb-lg-0">
              <ManageSidebar />
            </div>
            {/* left Sidebar ends */}

            {/* Rightbar contents */}
            <div className="col-lg-10 col-xxl-10 t-mb-30 mb-lg-0">
              <div className="t-bg-white">
                <div className="fk-scroll--pos-table-menu" data-simplebar>
                  <div className="t-pl-15 t-pr-15">
                    {/* Loading effect */}
                    {/* {loading === true ? (
                      tableLoading()
                    ) : ( */}
                      <div key="fragment3">
                        {/* next page data spin loading */}
                        <CustomSpinLoader loading={loading || dataPaginating}/>
                        {/* spin loading ends */}

                        <div className="row gx-2 align-items-center t-pt-15 t-pb-15">
                          <div className="col-md-6 col-lg-5 t-mb-15 mb-md-0">
                            <ul className="t-list fk-breadcrumb">
                              <li className="fk-breadcrumb__list">
                                <span className="t-link fk-breadcrumb__link text-capitalize">
                                  {!searchedStoreRequisition.searched
                                    ? _t(t("Store Requisition List"))
                                    : _t(t("Search Result"))}
                                </span>
                              </li>
                            </ul>
                          </div>
                          <div className="col-md-6 col-lg-7">
                            <div className="row gx-3 align-items-center">
                              {/* Search customer */}
                              <div className="col-md-9 t-mb-15 mb-md-0">
                                <div className="input-group">
                                  <div className="form-file">
                                    <input
                                      type="text"
                                      className="form-control border-0 form-control--light-1 rounded-left"
                                      placeholder={_t(t("Search")) + ".."}
                                      onChange={handleSearch}
                                    />
                                  </div>
                                  <button
                                    className="btn btn-primary rounded-right"
                                    type="button"
                                  >
                                    <i
                                      className="fa fa-search"
                                      aria-hidden="true"
                                    ></i>
                                  </button>
                                </div>
                              </div>

                              {/* Add customer modal trigger button */}
                              <div className="col-md-3 text-md-right">
                                <NavLink
                                  to="/dashboard/manage/stock/store-requisition-add"
                                  className="btn btn-primary xsm-text text-uppercase btn-lg btn-block rounded"
                                >
                                  {_t(t("add new"))}
                                </NavLink>
                              </div>
                            </div>
                          </div>
                        </div>
                        {/* Table */}
                        <div className="">
                          <table className="table table-bordered table-hover min-table-height">
                            <thead className="align-middle">
                              <tr>
                                <th
                                  scope="col"
                                  className="sm-text text-capitalize align-middle text-center border-1 border"
                                >
                                  {_t(t("S/L"))}
                                </th>

                                <th
                                  scope="col"
                                  className="sm-text text-capitalize align-middle text-center border-1 border"
                                >
                                  {_t(t("Document Number"))}
                                </th>

                                <th
                                  scope="col"
                                  className="sm-text text-capitalize align-middle text-center border-1 border"
                                >
                                  {_t(t("Document Date"))}
                                </th>

                                <th
                                  scope="col"
                                  className="sm-text text-capitalize align-middle text-center border-1 border"
                                >
                                  {_t(t("From Branch"))}
                                </th>

                                <th
                                  scope="col"
                                  className="sm-text text-capitalize align-middle text-center border-1 border"
                                >
                                  {_t(t("To Branch"))}
                                </th>

                                <th
                                  scope="col"
                                  className="sm-text text-capitalize align-middle text-center border-1 border"
                                >
                                  {_t(t("Remarks"))}
                                </th>

                                {/* <th
                                  scope="col"
                                  className="sm-text text-capitalize align-middle text-center border-1 border"
                                >
                                  {_t(t("Total"))}
                                </th> */}

                                <th
                                  scope="col"
                                  className="sm-text text-capitalize align-middle text-center border-1 border"
                                >
                                  {_t(t("Action"))}
                                </th>

                                <th
                                  scope="col"
                                  className="sm-text text-capitalize align-middle text-center border-1 border"
                                >
                                  {_t(t("Created By"))}
                                </th>

                                <th
                                  scope="col"
                                  className="sm-text text-capitalize align-middle text-center border-1 border"
                                >
                                  {_t(t("Updated By"))}
                                </th>

                                <th
                                  scope="col"
                                  className="sm-text text-capitalize align-middle text-center border-1 border"
                                >
                                  {_t(t("Posted By"))}
                                </th>
                              </tr>
                            </thead>
                            <tbody className="align-middle">
                              {/* loop here, logic === !search && haveData && haveDataLegnth > 0*/}
                              {!searchedStoreRequisition.searched
                                ? [
                                  storeRequisitionList && [
                                      storeRequisitionList.data.length === 0 ? (
                                        <tr className="align-middle">
                                          <td
                                            scope="row"
                                            colSpan="10"
                                            className="xsm-text align-middle text-center"
                                          >
                                            {_t(t("No data available"))}
                                          </td>
                                        </tr>
                                      ) : (
                                          storeRequisitionList.data.map((item, index) => {
                                          return (
                                            <tr
                                              className="align-middle"
                                              key={index}
                                            >
                                              <th
                                                scope="row"
                                                className="xsm-text text-capitalize align-middle text-center"
                                              >
                                                {index +
                                                  1 +
                                                  (storeRequisitionList.current_page -
                                                    1) *
                                                    storeRequisitionList.per_page}
                                              </th>

                                              <td className="xsm-text text-capitalize align-middle text-center">
                                                {item.document_identity}
                                              </td>

                                              <td className="xsm-text align-middle text-center">
                                                {item.document_date}
                                              </td>

                                              <td className="xsm-text text-capitalize align-middle text-center">
                                                {item?.from_branch?.name}
                                              </td>

                                              <td className="xsm-text text-capitalize align-middle text-center">
                                                {item?.to_branch?.name}
                                              </td>

                                              <td className="xsm-text text-capitalize align-middle text-center">                                                  
                                                {item.remarks}
                                              </td>

                                              {/* <td className="xsm-text align-middle text-center">
                                                {parseFloat(item.total_amount).toFixed(2)}
                                              </td> */}

                                              <td className="xsm-text text-capitalize align-middle text-center">
                                              <div className="d-flex justify-content-center">                                                    
                                                <button
                                                  className="btn btn-secondary ml-2 rounded-sm del-btn"
                                                  onClick={() => handleGetPrintData(item.id)}
                                                >
                                                  <i className="fa fa-print edit-icon"></i>
                                                </button>
                                                {
                                                  item?.is_post === 0 ? (
                                                    <button
                                                      className="btn btn-dark ml-2 rounded-sm del-btn"
                                                      title="Post requisition" 
                                                      style={{padding:"1px 0px 0px 1px"}}                                               
                                                      onClick={()=>handlePostApi(item.id)}
                                                      disabled={postingId === item.id}
                                                    >
                                                      <i className="fa fa-check-square-o" aria-hidden="true"></i>
                                                    </button>
                                                  ) : ""
                                                }
                                                <NavLink
                                                  className="btn btn-primary ml-2 rounded-sm"
                                                  to={`/dashboard/manage/stock/store-requisition-edit/${item.id}`}
                                                  style={{height:"1.7rem",width:"1.7rem"}}                                                                                                                                              
                                                >
                                                  <div className="d-flex align-items-center justify-content-center">
                                                    <i className={`${item?.is_post ? "fa fa-eye": "fa fa-pencil"} edit-icon`} aria-hidden="true"></i>
                                                  </div>
                                                </NavLink>
                                                <NavLink
                                                  title="duplicate store request"
                                                  to={`/dashboard/manage/stock/store-requisition-edit/${item.id}?duplicate=1`}
                                                  className="btn btn-success ml-2 rounded-sm del-btn"
                                                >
                                                  <i className="fa fa-clone"></i>  
                                                </NavLink>
                                                {/* <button
                                                className="btn btn-danger ml-2 rounded-sm del-btn"
                                                onClick={()=>handleDeleteConfirmation(item.id)}                                                    
                                                >                                                    
                                                  <MdDelete className="del-icon" />                                                    
                                                </button> */}
                                                {/* <button
                                                className="btn btn-secondary ml-2 rounded-sm del-btn"
                                                  onClick={()=>handleGetPrintData(item.id)}
                                                  >
                                                  <i className="fa fa-print edit-icon"></i>
                                                </button> */}
                                                </div>
                                              </td>

                                              <td className="xsm-text align-middle text-center">
                                                {item.created_by_name || "-"}
                                              </td>

                                              <td className="xsm-text align-middle text-center">
                                                {item.updated_by_name || "-"}
                                              </td>

                                              <td className="xsm-text align-middle text-center">
                                                {item.posted_by_name || item.post_by_name || "-"}
                                              </td>
                                            </tr>
                                          );
                                        })
                                      ),
                                    ],
                                  ]
                                : [
                                    /* searched data, logic === haveData*/
                                    searchedStoreRequisition && [
                                      searchedStoreRequisition.list.length === 0 ? (
                                        <tr className="align-middle">
                                          <td
                                            scope="row"
                                            colSpan="10"
                                            className="xsm-text align-middle text-center"
                                          >
                                            {_t(t("No data available"))}
                                          </td>
                                        </tr>
                                      ) : (
                                        searchedStoreRequisition.list.map(
                                          (item, index) => {
                                            return (
                                              <tr
                                                className="align-middle"
                                                key={index}
                                              >
                                                <th
                                                  scope="row"
                                                  className="xsm-text text-capitalize align-middle text-center"
                                                >
                                                  {index +
                                                    1 +
                                                    (storeRequisitionList.current_page -
                                                      1) *
                                                      storeRequisitionList.per_page}
                                                </th>

                                                <td className="xsm-text text-capitalize align-middle text-center">
                                                  {item.document_identity}
                                                </td>

                                                <td className="xsm-text align-middle text-center">
                                                  {item.document_date}
                                                </td>

                                                <td className="xsm-text text-capitalize align-middle text-center">
                                                  {item?.from_branch?.name}
                                                </td>

                                                <td className="xsm-text text-capitalize align-middle text-center">
                                                  {item?.to_branch?.name}
                                                </td>

                                                <td className="xsm-text text-capitalize align-middle text-center">
                                                  {item.remarks}
                                                </td>

                                                {/* <td className="xsm-text align-middle text-center">
                                                  {parseFloat(item.total_amount).toFixed(2)}
                                                </td> */}

                                                <td className="xsm-text text-capitalize align-middle text-center">
                                                <div className="d-flex justify-content-center">                                                    
                                                <button
                                                  className="btn btn-secondary ml-2 rounded-sm del-btn"
                                                  onClick={() => handleGetPrintData(item.id)}
                                                >
                                                  <i className="fa fa-print edit-icon"></i>
                                                </button>
                                                {
                                                  item?.is_post === 0 ? (
                                                    <button
                                                      className="btn btn-dark ml-2 rounded-sm del-btn"
                                                      title="Post requisition" 
                                                      style={{padding:"1px 0px 0px 1px"}}                                               
                                                      onClick={()=>handlePostApi(item.id)}
                                                    >
                                                      <i className="fa fa-check-square-o" aria-hidden="true"></i>
                                                    </button>
                                                  ) : ""
                                                }
                                                <NavLink
                                                  className="btn btn-primary ml-2 rounded-sm"
                                                  to={`/dashboard/manage/stock/store-requisition-edit/${item.id}`}
                                                  style={{height:"1.7rem",width:"1.7rem"}}                                                                                                                                              
                                                >
                                                  <div className="d-flex align-items-center justify-content-center">
                                                    <i className={`${item?.is_post ? "fa fa-eye": "fa fa-pencil"} edit-icon`} aria-hidden="true"></i>
                                                  </div>
                                                </NavLink>
                                                <NavLink
                                                  title="duplicate store request"
                                                  to={`/dashboard/manage/stock/store-requisition-edit/${item.id}?duplicate=1`}
                                                  className="btn btn-success ml-2 rounded-sm del-btn"
                                                >
                                                  <i className="fa fa-clone"></i>  
                                                </NavLink>
                                                {/* <button
                                                className="btn btn-danger ml-2 rounded-sm del-btn"
                                                onClick={()=>handleDeleteConfirmation(item.id)}                                                    
                                                >                                                    
                                                  <MdDelete className="del-icon" />                                                    
                                                </button> */}
                                                {/* <button
                                                className="btn btn-secondary ml-2 rounded-sm del-btn"
                                                  onClick={()=>handleGetPrintData(item.id)}
                                                  >
                                                  <i className="fa fa-print edit-icon"></i>
                                                </button> */}
                                                </div>
                                                </td>

                                                <td className="xsm-text align-middle text-center">
                                                  {item.created_by_name || "-"}
                                                </td>

                                                <td className="xsm-text align-middle text-center">
                                                  {item.updated_by_name || "-"}
                                                </td>

                                                <td className="xsm-text align-middle text-center">
                                                  {item.posted_by_name || item.post_by_name || "-"}
                                                </td>
                                              </tr>
                                            );
                                          }
                                        )
                                      ),
                                    ],
                                  ]}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    {/* )} */}
                  </div>
                </div>
              </div>

              {/* pagination loading effect */}
              {loading === true
                ? paginationLoading()
                : [
                    // logic === !searched
                    !searchedStoreRequisition.searched ? (
                      <div key="fragment4">
                        <div className="t-bg-white mt-1 t-pt-5 t-pb-5">
                          <div className="row align-items-center t-pl-15 t-pr-15">
                            <div className="col-md-7 t-mb-15 mb-md-0">
                              {/* pagination function */}
                              {pagination(storeRequisitionList, setPaginatedStoreRequisition)}
                            </div>
                            <div className="col-md-5">
                              <ul className="t-list d-flex justify-content-md-end align-items-center">
                                <li className="t-list__item">
                                  <span className="d-inline-block sm-text">
                                    {showingData(storeRequisitionList)}
                                  </span>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                    ) : (
                      // if searched
                      <div className="t-bg-white mt-1 t-pt-5 t-pb-5">
                        <div className="row align-items-center t-pl-15 t-pr-15">
                          <div className="col-md-7 t-mb-15 mb-md-0">
                            <ul className="t-list d-flex">
                              <li className="t-list__item no-pagination-style">
                                <button
                                  className="btn btn-primary btn-sm"
                                  onClick={() =>
                                    setSearchedStoreRequisition({
                                      ...searchedStoreRequisition,
                                      searched: false,
                                    })
                                  }
                                >
                                  {_t(t("Clear Search"))}
                                </button>
                              </li>
                            </ul>
                          </div>
                          <div className="col-md-5">
                            <ul className="t-list d-flex justify-content-md-end align-items-center">
                              <li className="t-list__item">
                                <span className="d-inline-block sm-text">
                                  {searchedShowingData(
                                    searchedStoreRequisition,
                                    storeRequisitionForSearch
                                  )}
                                </span>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    ),
                  ]}
            </div>
            {/* Rightbar contents end*/}
          </div>
        </div>
      </main>
      {/* main body ends */}
      <IngredientStockPrint
        name="Stock Requisition"
        newConsumption={newStockReq}
        newRow={newRow}
        print={componentRef}
      />
    </>
  );
}

export default StoreRequisition;